import React, { useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Container, Row, Col, Card, Modal } from 'react-bootstrap';
import contactbanner from '../Assets/Image/AchibementBanner.avif';
import '../Assets/WebsiteCss/contact.css';
import aboutimgofowner from '../Assets/Image/Mr.NarayanSalvi sir.jpg'
import certificate1 from '../Assets/Image/certificate1.jpg';
import certificate2 from '../Assets/Image/certificate2.jpg';
import certificate3 from '../Assets/Image/certificate3.jpg';
import ownerImg from '../Assets/Image/achivement4.jpg'
import teamImg from '../Assets/Image/achivement1.jpg'
import award1Img from '../Assets/Image/achivement2.jpg'
import award2Img from '../Assets/Image/achivement3.jpg'
import eventImg from '../Assets/Image/achivement5.jpg'
import { useState } from 'react';
import { Helmet } from "react-helmet";


export default function Team() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const images = [
    { src: ownerImg, title: 'Leadership That Inspires' },
    { src: teamImg, title: 'Preferred by Our Clients' },
    { src: award1Img, title: 'Trusted by Industry Clients' },
    { src: award2Img, title: 'Trusted by Valued Clients' },
    { src: eventImg, title: 'Successful Collaboration' },
  ];
  const certificates = [
    {
      src: certificate1,
      title: 'Big Impact Award 2025',
      description:
        'Awarded to Mr. Narayan Salvi for outstanding contribution to the manpower and namkeen industry. Presented by Ritu Shivpuri.',
    },
    {
      src: certificate2,
      title: 'Big Impact Award to Mr. Narayan Salvi',
      description:
        'This certificate acknowledges the dedication and leadership of Mr. Narayan Salvi in supporting skilled labor and manufacturing excellence across India.',
    },
  ];

  const [show, setShow] = useState(false);
  const [modalImg, setModalImg] = useState('');

  const handleShow = (img) => {
    setModalImg(img);
    setShow(true);
  };

  return (
    <>
      <div className="mainnav min-vh-100">
        <Helmet>
          <title>Proud Moments with Our Team & Clients | Narayan Salvi Namkeen Contractor</title>

          <meta
            name="description"
            content="Explore the inspiring journey of Narayan Salvi – with 27+ years of excellence in namkeen manufacturing, leadership, and nationwide client success. Discover our proud collaborations and achievements."
          />

          <meta
            name="keywords"
            content="Narayan Salvi, Namkeen Manufacturer, About Narayan Salvi, Namkeen Contractor, Founder Journey, Namkeen Production, Indian Snacks Leader, Ratlami Sev Expert, Client Success, Leadership, Bikaneri Bhujiya, Indori Mixture"
          />

          <meta name="author" content="Narayan Salvi Group" />

          {/* Open Graph Meta Tags */}
          <meta property="og:title" content="Proud Moments with Our Team & Clients" />
          <meta
            property="og:description"
            content="Meet Narayan Salvi – a leader in Indian namkeen production with over 27 years of success. See our journey, trusted clients, and impactful collaborations."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://nsnamkeenlabourcontractor.com/teamandachivements" />
          <meta property="og:image" content="https://nsnamkeenlabourcontractor.com/images/team-success-banner.jpg" />

          {/* Viewport for responsiveness */}
          <meta name="viewport" content="width=device-width, initial-scale=1" />

          {/* Favicon */}
          <link rel="icon" href="/favicon.ico" />
        </Helmet>

        {/* Banner */}
        <div className="service-container">
          <img src={contactbanner} alt="" className="servicenamkken img-fluid" />
          <div className="service-text">"Proud Moments with Our Team & Clients!"</div>
        </div>

        <Container>
          <div className="mb-2 mt-3" >
            <h2 className="middletext mb-3" data-aos="zoom-in">Meet the Founder | Our Journey of Success</h2>
            <Row>
              <Col lg={5} className="d-flex justify-content-center" >
                <img
                  src={aboutimgofowner}
                  alt=""
                  style={{ height: "300px", width: '80%', objectFit: 'fill', borderRadius: "8px" }}
                />
              </Col>
              <Col lg={7} >
                <p className='p-3' style={{ textAlign: "justify" }}>
                  I  <b>Narayan Salvi </b> have 27 years experience of manufacturing various namkeen products. My speciality in Bikaneri Moth Bhujiya, Indore Khatta Meetha Mixture, Special Ratlami Sev, Mast Kirn, Delhi Mix, Navratan Mix, Singh Bhujiya, Peenut, Special Long Sev, Bombay Mix, Mungdaal. I have expertise in making 300+ Namkeen products.

                  My purpose is to provide superior quality products & services to more people and in many regions. I have successfully completed many contracts of making namkeen products in All over India. I am providing complete solution from Making Namkeen to Packing.

                  Today, My products receiving wide recognition throughout various states Like Madhya Pradesh, Uttar Pradesh, Punjab, Maharastra and All over India. It nourishes my ambitions to expand its success across a large number of neighboring states with a wider range of products.

                  We offer crispy and tasty namkeen that is chief demanded by customers. Our mix namkeen and Ratlami Sev is the most famous one customers.
                </p>
              </Col>
            </Row>
          </div>

          <Container className="my-5">
            {/* Section Title */}
            <h2 className="middletext text-center mb-3" data-aos="fade-up">
              Our Certificates
            </h2>

            {/* Section Subtitle */}
            <p className="text-muted text-center mb-5 px-2" data-aos="fade-up" data-aos-delay="100">
              We are proud to be honored at the <strong>Big Impact Awards 2025</strong> in Udaipur for our
              outstanding contribution to the manpower and namkeen production industry. This recognition
              was presented to <strong>Mr. Narayan Salvi</strong>, Founder of NS Namkeen Labour Contractor –
              Apna Karigar, by actress <strong>Ritu Shivpuri</strong>. These certificates reflect our
              commitment to excellence and trust.
            </p>
            <Row className="justify-content-center">
              <Col md={6} sm={8} xs={12} className="text-center">
                <img
                  src={certificate3}
                  alt="Certificate"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "450px",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  onClick={() => handleShow(certificate3)}
                />
              </Col>
            </Row>
            {/* Loop Over Certificates */}
            {certificates.map((cert, index) => (
              <Row
                key={index}
                className={`align-items-center mb-5 ${index % 2 !== 0 ? 'flex-md-row-reverse' : ''}`}
                data-aos="fade-up"
              >
                {/* Image Side */}
                <Col md={6} className="mb-4 mb-md-0" onClick={() => handleShow(cert.src)}>
                  <div className="certificate-wrapper position-relative">
                    <span className="ribbon">Awarded</span>
                    <Card className="certificate-card shadow-sm border-0">
                      <Card.Img
                        src={cert.src}
                        alt={cert.title}
                        className="certificate-img rounded"
                        style={{ height: '100%', maxHeight: '450px', objectFit: 'cover', cursor: 'pointer' }}
                      />
                    </Card>
                  </div>
                </Col>

                {/* Text Side */}
                <Col md={6} className="d-flex flex-column justify-content-start">
                  <h4 className="fw-bold mb-2">{cert.title}</h4>
                  <p className="text-muted">{cert.description}</p>
                  <p>
                    <strong>Awarded to:</strong> Mr. Narayan Salvi <br />
                    <strong>Presented by:</strong> Actress Ritu Shivpuri <br />
                    <strong>Organization:</strong> NS Namkeen Labour Contractor – Apna Karigar
                  </p>
                </Col>
              </Row>
            ))}

            {/* Modal Image View */}
            <Modal show={show} onHide={() => setShow(false)} size="lg" centered>
              <Modal.Body className="p-0">
                <img src={modalImg} alt="Certificate Full View" className="w-100" />
              </Modal.Body>
            </Modal>
          </Container>
          
            <div className="d-flex justify-content-center">
              <div className="mb-4 mt-4">
                <h2 className="middletext mb-3 text-center" data-aos="zoom-in">A Glimpse of Our Showcase</h2>
                <p className="text-muted text-center mb-4">Watch how our vision turned into reality with hard work and dedication.</p>
                <div className="d-flex justify-content-center">
                  <video className="founder-video" controls>
                    <source src={require('../Assets/Image/Event video.mp4')} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>

            </div>

            <div className="d-flex justify-content-center">
              <div className="mb-4 mt-4">
                <h2 className="middletext mb-3 text-center" data-aos="zoom-in">BNI Delhi Exhibition 2025 – Market Showcase</h2>
                <p className="text-muted text-center mb-4" style={{}}>Watch how our vision turned into reality as we showcased our products at the BNI Delhi Exhibition through hard work and dedication.</p>
                <div className="d-flex justify-content-center">
                  <video className="founder-video2" controls>
                    <source src={require('../Assets/Image/narayansalviVideo2.mp4')} type="video/mp4"  />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>

            </div>
          

        </Container>

      </div>
    </>
  )
}
